var styles = {
  lastChild: {
    marginRight: 0
  },

  select: {
    width: '170px'
  },

  hidden: {
    display: 'none'
  }
};

export default styles;
